module.exports = __webpack_public_path__ + "img/1F1EC-1F1EE.2afc85a5.svg";